import { Pipe, PipeTransform } from '@angular/core';
import { TabloGroupConfig } from '@ui/tablo-generator/types';

@Pipe({
    name: 'generateSingleChildTransform',
    standalone: false
})
export class GenerateSingleChildTransformPipe implements PipeTransform {
  transform(value: TabloGroupConfig, index: number): string {
    if (
      typeof value.singleChildConfig !== 'undefined' &&
      typeof value.singleChildConfig[index] !== 'undefined'
    ) {
      return `translate(${value.singleChildConfig[index].x ?? 0}px, ${
        value.singleChildConfig[index].y ?? 0
      }px)`;
    }
    return 'translate(0px, 0px)';
  }
}
